// use lodash! https://lodash.com/docs/4.17.15
import scrollToForm from "./components/scrollToForm";
import autoSubmit from "./components/autoSubmit";

import ArrowObs from './helpers/IntersectionalObservers'

const fndryThemeInitWrapper = () => {
    autoSubmit()
    document.querySelector('.footer-arrow').addEventListener('click', function () {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior:"smooth"
        });
    });
    ArrowObs();
};

window.fndryThemeInitWrapper = fndryThemeInitWrapper;

// eslint-disable-next-line no-unused-expressions
document.body ? fndryThemeInitWrapper() : document.addEventListener('DOMContentLoaded', fndryThemeInitWrapper, false);

// force scrollTo to occur after images load, as this affects layout
if (document.readyState === 'complete') {
    scrollToForm()
} else {
    window.addEventListener('load', () => {
        scrollToForm()
    }, false);
}
